export async function withRequestTimeout<T>(
  timeoutMs: number, request: (signal: AbortSignal) => Promise<T>, signal?: AbortSignal,
): Promise<T> {
  const controller = new AbortController();
  let abortReason: unknown;
  const abort = (reason: unknown): void => {
    if (controller.signal.aborted) return;
    abortReason = reason;
    controller.abort(reason);
  };
  const cancel = (): void => abort(signal?.reason ?? new DOMException('Request cancelled', 'AbortError'));
  if (signal?.aborted) {
    cancel();
    throw abortReason;
  }
  signal?.addEventListener('abort', cancel, { once: true });
  const timer = setTimeout(() => abort(new DOMException('Request timed out', 'TimeoutError')), timeoutMs);
  try {
    return await request(controller.signal);
  } catch (error) {
    if (controller.signal.aborted) throw abortReason;
    throw error;
  } finally {
    clearTimeout(timer);
    signal?.removeEventListener('abort', cancel);
  }
}
